exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-page {\n  padding-top: 68px;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Login/containers/Login.less
// module id = 1083
// module chunks = 0